<script setup>
import ModuleForm from '@frontJs/components/forms/ModuleForm.vue';
import DefaultLayout from '@frontJs/layouts/DefaultLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { module, moduleTypes } = defineProps({
    module: {
        required: false,
    },
    moduleTypes: {
        required: true,
        type: Array,
    },
});

defineOptions({ layout: DefaultLayout });
</script>

<template>
    <Head>
        <title>
            Mettre à jour le module #{{ module.key }} - Modules - Datakepler
        </title>
    </Head>

    <PageTitle> Modules - Mettre à jour le module #{{ module.key }} </PageTitle>

    <ModuleForm :module="module" :module-types="moduleTypes" />
</template>
